/*
 * Public API Surface of pepperi-lib/files-uploader
 */
export * from './files-uploader.module';
export * from './files-uploader.component';
